import script from "./SubscribeButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscribeButton.vue?vue&type=script&setup=true&lang=js"

import "./SubscribeButton.vue?vue&type=style&index=0&id=5cc078ae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cc078ae"]])

export default __exports__